/**
 * Zonas horarias que acepta el firmware Lum.
 * El valor es la regla POSIX que se envía al dispositivo.
 * Van agrupadas por región para que el desplegable no liste todas a la vez.
 */

export const LumTimeZoneRegions = [
  {
    id: "Europe",
    zones: [
      { name: "Europe/Amsterdam", label: "Amsterdam", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Andorra", label: "Andorra", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Astrakhan", label: "Astrakhan", posix: "<+04>-4" },
      { name: "Europe/Athens", label: "Athens", posix: "EET-2EEST,M3.5.0/3,M10.5.0/4" },
      { name: "Europe/Belgrade", label: "Belgrade", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Berlin", label: "Berlin", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Bratislava", label: "Bratislava", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Brussels", label: "Brussels", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Bucharest", label: "Bucharest", posix: "EET-2EEST,M3.5.0/3,M10.5.0/4" },
      { name: "Europe/Budapest", label: "Budapest", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Busingen", label: "Busingen", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Chisinau", label: "Chisinau", posix: "EET-2EEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Copenhagen", label: "Copenhagen", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Dublin", label: "Dublin", posix: "IST-1GMT0,M10.5.0,M3.5.0/1" },
      { name: "Europe/Gibraltar", label: "Gibraltar", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Guernsey", label: "Guernsey", posix: "GMT0BST,M3.5.0/1,M10.5.0" },
      { name: "Europe/Helsinki", label: "Helsinki", posix: "EET-2EEST,M3.5.0/3,M10.5.0/4" },
      { name: "Europe/Isle_of_Man", label: "Isle of Man", posix: "GMT0BST,M3.5.0/1,M10.5.0" },
      { name: "Europe/Istanbul", label: "Istanbul", posix: "<+03>-3" },
      { name: "Europe/Jersey", label: "Jersey", posix: "GMT0BST,M3.5.0/1,M10.5.0" },
      { name: "Europe/Kaliningrad", label: "Kaliningrad", posix: "EET-2" },
      { name: "Europe/Kiev", label: "Kiev", posix: "EET-2EEST,M3.5.0/3,M10.5.0/4" },
      { name: "Europe/Kirov", label: "Kirov", posix: "MSK-3" },
      { name: "Europe/Lisbon", label: "Lisbon", posix: "WET0WEST,M3.5.0/1,M10.5.0" },
      { name: "Europe/Ljubljana", label: "Ljubljana", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/London", label: "London", posix: "GMT0BST,M3.5.0/1,M10.5.0" },
      { name: "Europe/Luxembourg", label: "Luxembourg", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Madrid", label: "Madrid", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Malta", label: "Malta", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Mariehamn", label: "Mariehamn", posix: "EET-2EEST,M3.5.0/3,M10.5.0/4" },
      { name: "Europe/Minsk", label: "Minsk", posix: "<+03>-3" },
      { name: "Europe/Monaco", label: "Monaco", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Moscow", label: "Moscow", posix: "MSK-3" },
      { name: "Europe/Oslo", label: "Oslo", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Paris", label: "Paris", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Podgorica", label: "Podgorica", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Prague", label: "Prague", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Riga", label: "Riga", posix: "EET-2EEST,M3.5.0/3,M10.5.0/4" },
      { name: "Europe/Rome", label: "Rome", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Samara", label: "Samara", posix: "<+04>-4" },
      { name: "Europe/San_Marino", label: "San Marino", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Sarajevo", label: "Sarajevo", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Saratov", label: "Saratov", posix: "<+04>-4" },
      { name: "Europe/Simferopol", label: "Simferopol", posix: "MSK-3" },
      { name: "Europe/Skopje", label: "Skopje", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Sofia", label: "Sofia", posix: "EET-2EEST,M3.5.0/3,M10.5.0/4" },
      { name: "Europe/Stockholm", label: "Stockholm", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Tallinn", label: "Tallinn", posix: "EET-2EEST,M3.5.0/3,M10.5.0/4" },
      { name: "Europe/Tirane", label: "Tirane", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Ulyanovsk", label: "Ulyanovsk", posix: "<+04>-4" },
      { name: "Europe/Uzhgorod", label: "Uzhgorod", posix: "EET-2EEST,M3.5.0/3,M10.5.0/4" },
      { name: "Europe/Vaduz", label: "Vaduz", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Vatican", label: "Vatican", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Vienna", label: "Vienna", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Vilnius", label: "Vilnius", posix: "EET-2EEST,M3.5.0/3,M10.5.0/4" },
      { name: "Europe/Volgograd", label: "Volgograd", posix: "MSK-3" },
      { name: "Europe/Warsaw", label: "Warsaw", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Zagreb", label: "Zagreb", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Europe/Zaporozhye", label: "Zaporozhye", posix: "EET-2EEST,M3.5.0/3,M10.5.0/4" },
      { name: "Europe/Zurich", label: "Zurich", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
    ],
  },
  {
    id: "Africa",
    zones: [
      { name: "Africa/Abidjan", label: "Abidjan", posix: "GMT0" },
      { name: "Africa/Accra", label: "Accra", posix: "GMT0" },
      { name: "Africa/Addis_Ababa", label: "Addis Ababa", posix: "EAT-3" },
      { name: "Africa/Algiers", label: "Algiers", posix: "CET-1" },
      { name: "Africa/Asmara", label: "Asmara", posix: "EAT-3" },
      { name: "Africa/Bamako", label: "Bamako", posix: "GMT0" },
      { name: "Africa/Bangui", label: "Bangui", posix: "WAT-1" },
      { name: "Africa/Banjul", label: "Banjul", posix: "GMT0" },
      { name: "Africa/Bissau", label: "Bissau", posix: "GMT0" },
      { name: "Africa/Blantyre", label: "Blantyre", posix: "CAT-2" },
      { name: "Africa/Brazzaville", label: "Brazzaville", posix: "WAT-1" },
      { name: "Africa/Bujumbura", label: "Bujumbura", posix: "CAT-2" },
      { name: "Africa/Cairo", label: "Cairo", posix: "EET-2EEST,M4.5.5/0,M10.5.4/24" },
      { name: "Africa/Casablanca", label: "Casablanca", posix: "<+01>-1" },
      { name: "Africa/Ceuta", label: "Ceuta", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
      { name: "Africa/Conakry", label: "Conakry", posix: "GMT0" },
      { name: "Africa/Dakar", label: "Dakar", posix: "GMT0" },
      { name: "Africa/Dar_es_Salaam", label: "Dar es Salaam", posix: "EAT-3" },
      { name: "Africa/Djibouti", label: "Djibouti", posix: "EAT-3" },
      { name: "Africa/Douala", label: "Douala", posix: "WAT-1" },
      { name: "Africa/El_Aaiun", label: "El Aaiun", posix: "<+01>-1" },
      { name: "Africa/Freetown", label: "Freetown", posix: "GMT0" },
      { name: "Africa/Gaborone", label: "Gaborone", posix: "CAT-2" },
      { name: "Africa/Harare", label: "Harare", posix: "CAT-2" },
      { name: "Africa/Johannesburg", label: "Johannesburg", posix: "SAST-2" },
      { name: "Africa/Juba", label: "Juba", posix: "CAT-2" },
      { name: "Africa/Kampala", label: "Kampala", posix: "EAT-3" },
      { name: "Africa/Khartoum", label: "Khartoum", posix: "CAT-2" },
      { name: "Africa/Kigali", label: "Kigali", posix: "CAT-2" },
      { name: "Africa/Kinshasa", label: "Kinshasa", posix: "WAT-1" },
      { name: "Africa/Lagos", label: "Lagos", posix: "WAT-1" },
      { name: "Africa/Libreville", label: "Libreville", posix: "WAT-1" },
      { name: "Africa/Lome", label: "Lome", posix: "GMT0" },
      { name: "Africa/Luanda", label: "Luanda", posix: "WAT-1" },
      { name: "Africa/Lubumbashi", label: "Lubumbashi", posix: "CAT-2" },
      { name: "Africa/Lusaka", label: "Lusaka", posix: "CAT-2" },
      { name: "Africa/Malabo", label: "Malabo", posix: "WAT-1" },
      { name: "Africa/Maputo", label: "Maputo", posix: "CAT-2" },
      { name: "Africa/Maseru", label: "Maseru", posix: "SAST-2" },
      { name: "Africa/Mbabane", label: "Mbabane", posix: "SAST-2" },
      { name: "Africa/Mogadishu", label: "Mogadishu", posix: "EAT-3" },
      { name: "Africa/Monrovia", label: "Monrovia", posix: "GMT0" },
      { name: "Africa/Nairobi", label: "Nairobi", posix: "EAT-3" },
      { name: "Africa/Ndjamena", label: "Ndjamena", posix: "WAT-1" },
      { name: "Africa/Niamey", label: "Niamey", posix: "WAT-1" },
      { name: "Africa/Nouakchott", label: "Nouakchott", posix: "GMT0" },
      { name: "Africa/Ouagadougou", label: "Ouagadougou", posix: "GMT0" },
      { name: "Africa/Porto-Novo", label: "Porto-Novo", posix: "WAT-1" },
      { name: "Africa/Sao_Tome", label: "Sao Tome", posix: "GMT0" },
      { name: "Africa/Tripoli", label: "Tripoli", posix: "EET-2" },
      { name: "Africa/Tunis", label: "Tunis", posix: "CET-1" },
      { name: "Africa/Windhoek", label: "Windhoek", posix: "CAT-2" },
    ],
  },
  {
    id: "America",
    zones: [
      { name: "America/Adak", label: "Adak", posix: "HST10HDT,M3.2.0,M11.1.0" },
      { name: "America/Anchorage", label: "Anchorage", posix: "AKST9AKDT,M3.2.0,M11.1.0" },
      { name: "America/Anguilla", label: "Anguilla", posix: "AST4" },
      { name: "America/Antigua", label: "Antigua", posix: "AST4" },
      { name: "America/Araguaina", label: "Araguaina", posix: "<-03>3" },
      { name: "America/Argentina/Buenos_Aires", label: "Argentina/Buenos Aires", posix: "<-03>3" },
      { name: "America/Argentina/Catamarca", label: "Argentina/Catamarca", posix: "<-03>3" },
      { name: "America/Argentina/Cordoba", label: "Argentina/Cordoba", posix: "<-03>3" },
      { name: "America/Argentina/Jujuy", label: "Argentina/Jujuy", posix: "<-03>3" },
      { name: "America/Argentina/La_Rioja", label: "Argentina/La Rioja", posix: "<-03>3" },
      { name: "America/Argentina/Mendoza", label: "Argentina/Mendoza", posix: "<-03>3" },
      { name: "America/Argentina/Rio_Gallegos", label: "Argentina/Rio Gallegos", posix: "<-03>3" },
      { name: "America/Argentina/Salta", label: "Argentina/Salta", posix: "<-03>3" },
      { name: "America/Argentina/San_Juan", label: "Argentina/San Juan", posix: "<-03>3" },
      { name: "America/Argentina/San_Luis", label: "Argentina/San Luis", posix: "<-03>3" },
      { name: "America/Argentina/Tucuman", label: "Argentina/Tucuman", posix: "<-03>3" },
      { name: "America/Argentina/Ushuaia", label: "Argentina/Ushuaia", posix: "<-03>3" },
      { name: "America/Aruba", label: "Aruba", posix: "AST4" },
      { name: "America/Asuncion", label: "Asuncion", posix: "<-03>3" },
      { name: "America/Atikokan", label: "Atikokan", posix: "EST5" },
      { name: "America/Bahia", label: "Bahia", posix: "<-03>3" },
      { name: "America/Bahia_Banderas", label: "Bahia Banderas", posix: "CST6" },
      { name: "America/Barbados", label: "Barbados", posix: "AST4" },
      { name: "America/Belem", label: "Belem", posix: "<-03>3" },
      { name: "America/Belize", label: "Belize", posix: "CST6" },
      { name: "America/Blanc-Sablon", label: "Blanc-Sablon", posix: "AST4" },
      { name: "America/Boa_Vista", label: "Boa Vista", posix: "<-04>4" },
      { name: "America/Bogota", label: "Bogota", posix: "<-05>5" },
      { name: "America/Boise", label: "Boise", posix: "MST7MDT,M3.2.0,M11.1.0" },
      { name: "America/Cambridge_Bay", label: "Cambridge Bay", posix: "MST7MDT,M3.2.0,M11.1.0" },
      { name: "America/Campo_Grande", label: "Campo Grande", posix: "<-04>4" },
      { name: "America/Cancun", label: "Cancun", posix: "EST5" },
      { name: "America/Caracas", label: "Caracas", posix: "<-04>4" },
      { name: "America/Cayenne", label: "Cayenne", posix: "<-03>3" },
      { name: "America/Cayman", label: "Cayman", posix: "EST5" },
      { name: "America/Chicago", label: "Chicago", posix: "CST6CDT,M3.2.0,M11.1.0" },
      { name: "America/Chihuahua", label: "Chihuahua", posix: "CST6" },
      { name: "America/Costa_Rica", label: "Costa Rica", posix: "CST6" },
      { name: "America/Creston", label: "Creston", posix: "MST7" },
      { name: "America/Cuiaba", label: "Cuiaba", posix: "<-04>4" },
      { name: "America/Curacao", label: "Curacao", posix: "AST4" },
      { name: "America/Danmarkshavn", label: "Danmarkshavn", posix: "GMT0" },
      { name: "America/Dawson", label: "Dawson", posix: "MST7" },
      { name: "America/Dawson_Creek", label: "Dawson Creek", posix: "MST7" },
      { name: "America/Denver", label: "Denver", posix: "MST7MDT,M3.2.0,M11.1.0" },
      { name: "America/Detroit", label: "Detroit", posix: "EST5EDT,M3.2.0,M11.1.0" },
      { name: "America/Dominica", label: "Dominica", posix: "AST4" },
      { name: "America/Edmonton", label: "Edmonton", posix: "MST7MDT,M3.2.0,M11.1.0" },
      { name: "America/Eirunepe", label: "Eirunepe", posix: "<-05>5" },
      { name: "America/El_Salvador", label: "El Salvador", posix: "CST6" },
      { name: "America/Fort_Nelson", label: "Fort Nelson", posix: "MST7" },
      { name: "America/Fortaleza", label: "Fortaleza", posix: "<-03>3" },
      { name: "America/Glace_Bay", label: "Glace Bay", posix: "AST4ADT,M3.2.0,M11.1.0" },
      { name: "America/Godthab", label: "Godthab", posix: "<-02>2<-01>,M3.5.0/-1,M10.5.0/0" },
      { name: "America/Goose_Bay", label: "Goose Bay", posix: "AST4ADT,M3.2.0,M11.1.0" },
      { name: "America/Grand_Turk", label: "Grand Turk", posix: "EST5EDT,M3.2.0,M11.1.0" },
      { name: "America/Grenada", label: "Grenada", posix: "AST4" },
      { name: "America/Guadeloupe", label: "Guadeloupe", posix: "AST4" },
      { name: "America/Guatemala", label: "Guatemala", posix: "CST6" },
      { name: "America/Guayaquil", label: "Guayaquil", posix: "<-05>5" },
      { name: "America/Guyana", label: "Guyana", posix: "<-04>4" },
      { name: "America/Halifax", label: "Halifax", posix: "AST4ADT,M3.2.0,M11.1.0" },
      { name: "America/Havana", label: "Havana", posix: "CST5CDT,M3.2.0/0,M11.1.0/1" },
      { name: "America/Hermosillo", label: "Hermosillo", posix: "MST7" },
      { name: "America/Indiana/Indianapolis", label: "Indiana/Indianapolis", posix: "EST5EDT,M3.2.0,M11.1.0" },
      { name: "America/Indiana/Knox", label: "Indiana/Knox", posix: "CST6CDT,M3.2.0,M11.1.0" },
      { name: "America/Indiana/Marengo", label: "Indiana/Marengo", posix: "EST5EDT,M3.2.0,M11.1.0" },
      { name: "America/Indiana/Petersburg", label: "Indiana/Petersburg", posix: "EST5EDT,M3.2.0,M11.1.0" },
      { name: "America/Indiana/Tell_City", label: "Indiana/Tell City", posix: "CST6CDT,M3.2.0,M11.1.0" },
      { name: "America/Indiana/Vevay", label: "Indiana/Vevay", posix: "EST5EDT,M3.2.0,M11.1.0" },
      { name: "America/Indiana/Vincennes", label: "Indiana/Vincennes", posix: "EST5EDT,M3.2.0,M11.1.0" },
      { name: "America/Indiana/Winamac", label: "Indiana/Winamac", posix: "EST5EDT,M3.2.0,M11.1.0" },
      { name: "America/Inuvik", label: "Inuvik", posix: "MST7MDT,M3.2.0,M11.1.0" },
      { name: "America/Iqaluit", label: "Iqaluit", posix: "EST5EDT,M3.2.0,M11.1.0" },
      { name: "America/Jamaica", label: "Jamaica", posix: "EST5" },
      { name: "America/Juneau", label: "Juneau", posix: "AKST9AKDT,M3.2.0,M11.1.0" },
      { name: "America/Kentucky/Louisville", label: "Kentucky/Louisville", posix: "EST5EDT,M3.2.0,M11.1.0" },
      { name: "America/Kentucky/Monticello", label: "Kentucky/Monticello", posix: "EST5EDT,M3.2.0,M11.1.0" },
      { name: "America/Kralendijk", label: "Kralendijk", posix: "AST4" },
      { name: "America/La_Paz", label: "La Paz", posix: "<-04>4" },
      { name: "America/Lima", label: "Lima", posix: "<-05>5" },
      { name: "America/Los_Angeles", label: "Los Angeles", posix: "PST8PDT,M3.2.0,M11.1.0" },
      { name: "America/Lower_Princes", label: "Lower Princes", posix: "AST4" },
      { name: "America/Maceio", label: "Maceio", posix: "<-03>3" },
      { name: "America/Managua", label: "Managua", posix: "CST6" },
      { name: "America/Manaus", label: "Manaus", posix: "<-04>4" },
      { name: "America/Marigot", label: "Marigot", posix: "AST4" },
      { name: "America/Martinique", label: "Martinique", posix: "AST4" },
      { name: "America/Matamoros", label: "Matamoros", posix: "CST6CDT,M3.2.0,M11.1.0" },
      { name: "America/Mazatlan", label: "Mazatlan", posix: "MST7" },
      { name: "America/Menominee", label: "Menominee", posix: "CST6CDT,M3.2.0,M11.1.0" },
      { name: "America/Merida", label: "Merida", posix: "CST6" },
      { name: "America/Metlakatla", label: "Metlakatla", posix: "AKST9AKDT,M3.2.0,M11.1.0" },
      { name: "America/Mexico_City", label: "Mexico City", posix: "CST6" },
      { name: "America/Miquelon", label: "Miquelon", posix: "<-03>3<-02>,M3.2.0,M11.1.0" },
      { name: "America/Moncton", label: "Moncton", posix: "AST4ADT,M3.2.0,M11.1.0" },
      { name: "America/Monterrey", label: "Monterrey", posix: "CST6" },
      { name: "America/Montevideo", label: "Montevideo", posix: "<-03>3" },
      { name: "America/Montreal", label: "Montreal", posix: "EST5EDT,M3.2.0,M11.1.0" },
      { name: "America/Montserrat", label: "Montserrat", posix: "AST4" },
      { name: "America/Nassau", label: "Nassau", posix: "EST5EDT,M3.2.0,M11.1.0" },
      { name: "America/New_York", label: "New York", posix: "EST5EDT,M3.2.0,M11.1.0" },
      { name: "America/Nipigon", label: "Nipigon", posix: "EST5EDT,M3.2.0,M11.1.0" },
      { name: "America/Nome", label: "Nome", posix: "AKST9AKDT,M3.2.0,M11.1.0" },
      { name: "America/Noronha", label: "Noronha", posix: "<-02>2" },
      { name: "America/North_Dakota/Beulah", label: "North Dakota/Beulah", posix: "CST6CDT,M3.2.0,M11.1.0" },
      { name: "America/North_Dakota/Center", label: "North Dakota/Center", posix: "CST6CDT,M3.2.0,M11.1.0" },
      { name: "America/North_Dakota/New_Salem", label: "North Dakota/New Salem", posix: "CST6CDT,M3.2.0,M11.1.0" },
      { name: "America/Nuuk", label: "Nuuk", posix: "<-02>2<-01>,M3.5.0/-1,M10.5.0/0" },
      { name: "America/Ojinaga", label: "Ojinaga", posix: "CST6CDT,M3.2.0,M11.1.0" },
      { name: "America/Panama", label: "Panama", posix: "EST5" },
      { name: "America/Pangnirtung", label: "Pangnirtung", posix: "EST5EDT,M3.2.0,M11.1.0" },
      { name: "America/Paramaribo", label: "Paramaribo", posix: "<-03>3" },
      { name: "America/Phoenix", label: "Phoenix", posix: "MST7" },
      { name: "America/Port_of_Spain", label: "Port of Spain", posix: "AST4" },
      { name: "America/Port-au-Prince", label: "Port-au-Prince", posix: "EST5EDT,M3.2.0,M11.1.0" },
      { name: "America/Porto_Velho", label: "Porto Velho", posix: "<-04>4" },
      { name: "America/Puerto_Rico", label: "Puerto Rico", posix: "AST4" },
      { name: "America/Punta_Arenas", label: "Punta Arenas", posix: "<-03>3" },
      { name: "America/Rainy_River", label: "Rainy River", posix: "CST6CDT,M3.2.0,M11.1.0" },
      { name: "America/Rankin_Inlet", label: "Rankin Inlet", posix: "CST6CDT,M3.2.0,M11.1.0" },
      { name: "America/Recife", label: "Recife", posix: "<-03>3" },
      { name: "America/Regina", label: "Regina", posix: "CST6" },
      { name: "America/Resolute", label: "Resolute", posix: "CST6CDT,M3.2.0,M11.1.0" },
      { name: "America/Rio_Branco", label: "Rio Branco", posix: "<-05>5" },
      { name: "America/Santarem", label: "Santarem", posix: "<-03>3" },
      { name: "America/Santiago", label: "Santiago", posix: "<-04>4<-03>,M9.1.6/24,M4.1.6/24" },
      { name: "America/Santo_Domingo", label: "Santo Domingo", posix: "AST4" },
      { name: "America/Sao_Paulo", label: "Sao Paulo", posix: "<-03>3" },
      { name: "America/Scoresbysund", label: "Scoresbysund", posix: "<-02>2<-01>,M3.5.0/-1,M10.5.0/0" },
      { name: "America/Sitka", label: "Sitka", posix: "AKST9AKDT,M3.2.0,M11.1.0" },
      { name: "America/St_Barthelemy", label: "St Barthelemy", posix: "AST4" },
      { name: "America/St_Johns", label: "St Johns", posix: "NST3:30NDT,M3.2.0,M11.1.0" },
      { name: "America/St_Kitts", label: "St Kitts", posix: "AST4" },
      { name: "America/St_Lucia", label: "St Lucia", posix: "AST4" },
      { name: "America/St_Thomas", label: "St Thomas", posix: "AST4" },
      { name: "America/St_Vincent", label: "St Vincent", posix: "AST4" },
      { name: "America/Swift_Current", label: "Swift Current", posix: "CST6" },
      { name: "America/Tegucigalpa", label: "Tegucigalpa", posix: "CST6" },
      { name: "America/Thule", label: "Thule", posix: "AST4ADT,M3.2.0,M11.1.0" },
      { name: "America/Thunder_Bay", label: "Thunder Bay", posix: "EST5EDT,M3.2.0,M11.1.0" },
      { name: "America/Tijuana", label: "Tijuana", posix: "PST8PDT,M3.2.0,M11.1.0" },
      { name: "America/Toronto", label: "Toronto", posix: "EST5EDT,M3.2.0,M11.1.0" },
      { name: "America/Tortola", label: "Tortola", posix: "AST4" },
      { name: "America/Vancouver", label: "Vancouver", posix: "PST8PDT,M3.2.0,M11.1.0" },
      { name: "America/Whitehorse", label: "Whitehorse", posix: "MST7" },
      { name: "America/Winnipeg", label: "Winnipeg", posix: "CST6CDT,M3.2.0,M11.1.0" },
      { name: "America/Yakutat", label: "Yakutat", posix: "AKST9AKDT,M3.2.0,M11.1.0" },
      { name: "America/Yellowknife", label: "Yellowknife", posix: "MST7MDT,M3.2.0,M11.1.0" },
    ],
  },
  {
    id: "Asia",
    zones: [
      { name: "Asia/Aden", label: "Aden", posix: "<+03>-3" },
      { name: "Asia/Almaty", label: "Almaty", posix: "<+05>-5" },
      { name: "Asia/Amman", label: "Amman", posix: "<+03>-3" },
      { name: "Asia/Anadyr", label: "Anadyr", posix: "<+12>-12" },
      { name: "Asia/Aqtau", label: "Aqtau", posix: "<+05>-5" },
      { name: "Asia/Aqtobe", label: "Aqtobe", posix: "<+05>-5" },
      { name: "Asia/Ashgabat", label: "Ashgabat", posix: "<+05>-5" },
      { name: "Asia/Atyrau", label: "Atyrau", posix: "<+05>-5" },
      { name: "Asia/Baghdad", label: "Baghdad", posix: "<+03>-3" },
      { name: "Asia/Bahrain", label: "Bahrain", posix: "<+03>-3" },
      { name: "Asia/Baku", label: "Baku", posix: "<+04>-4" },
      { name: "Asia/Bangkok", label: "Bangkok", posix: "<+07>-7" },
      { name: "Asia/Barnaul", label: "Barnaul", posix: "<+07>-7" },
      { name: "Asia/Beirut", label: "Beirut", posix: "EET-2EEST,M3.5.0/0,M10.5.0/0" },
      { name: "Asia/Bishkek", label: "Bishkek", posix: "<+06>-6" },
      { name: "Asia/Brunei", label: "Brunei", posix: "<+08>-8" },
      { name: "Asia/Chita", label: "Chita", posix: "<+09>-9" },
      { name: "Asia/Choibalsan", label: "Choibalsan", posix: "<+08>-8" },
      { name: "Asia/Colombo", label: "Colombo", posix: "<+0530>-5:30" },
      { name: "Asia/Damascus", label: "Damascus", posix: "<+03>-3" },
      { name: "Asia/Dhaka", label: "Dhaka", posix: "<+06>-6" },
      { name: "Asia/Dili", label: "Dili", posix: "<+09>-9" },
      { name: "Asia/Dubai", label: "Dubai", posix: "<+04>-4" },
      { name: "Asia/Dushanbe", label: "Dushanbe", posix: "<+05>-5" },
      { name: "Asia/Famagusta", label: "Famagusta", posix: "EET-2EEST,M3.5.0/3,M10.5.0/4" },
      { name: "Asia/Gaza", label: "Gaza", posix: "EET-2EEST,M3.4.4/50,M10.4.4/50" },
      { name: "Asia/Hebron", label: "Hebron", posix: "EET-2EEST,M3.4.4/50,M10.4.4/50" },
      { name: "Asia/Ho_Chi_Minh", label: "Ho Chi Minh", posix: "<+07>-7" },
      { name: "Asia/Hong_Kong", label: "Hong Kong", posix: "HKT-8" },
      { name: "Asia/Hovd", label: "Hovd", posix: "<+07>-7" },
      { name: "Asia/Irkutsk", label: "Irkutsk", posix: "<+08>-8" },
      { name: "Asia/Jakarta", label: "Jakarta", posix: "WIB-7" },
      { name: "Asia/Jayapura", label: "Jayapura", posix: "WIT-9" },
      { name: "Asia/Jerusalem", label: "Jerusalem", posix: "IST-2IDT,M3.4.4/26,M10.5.0" },
      { name: "Asia/Kabul", label: "Kabul", posix: "<+0430>-4:30" },
      { name: "Asia/Kamchatka", label: "Kamchatka", posix: "<+12>-12" },
      { name: "Asia/Karachi", label: "Karachi", posix: "PKT-5" },
      { name: "Asia/Kathmandu", label: "Kathmandu", posix: "<+0545>-5:45" },
      { name: "Asia/Khandyga", label: "Khandyga", posix: "<+09>-9" },
      { name: "Asia/Kolkata", label: "Kolkata", posix: "IST-5:30" },
      { name: "Asia/Krasnoyarsk", label: "Krasnoyarsk", posix: "<+07>-7" },
      { name: "Asia/Kuala_Lumpur", label: "Kuala Lumpur", posix: "<+08>-8" },
      { name: "Asia/Kuching", label: "Kuching", posix: "<+08>-8" },
      { name: "Asia/Kuwait", label: "Kuwait", posix: "<+03>-3" },
      { name: "Asia/Macau", label: "Macau", posix: "CST-8" },
      { name: "Asia/Magadan", label: "Magadan", posix: "<+11>-11" },
      { name: "Asia/Makassar", label: "Makassar", posix: "WITA-8" },
      { name: "Asia/Manila", label: "Manila", posix: "PST-8" },
      { name: "Asia/Muscat", label: "Muscat", posix: "<+04>-4" },
      { name: "Asia/Nicosia", label: "Nicosia", posix: "EET-2EEST,M3.5.0/3,M10.5.0/4" },
      { name: "Asia/Novokuznetsk", label: "Novokuznetsk", posix: "<+07>-7" },
      { name: "Asia/Novosibirsk", label: "Novosibirsk", posix: "<+07>-7" },
      { name: "Asia/Omsk", label: "Omsk", posix: "<+06>-6" },
      { name: "Asia/Oral", label: "Oral", posix: "<+05>-5" },
      { name: "Asia/Phnom_Penh", label: "Phnom Penh", posix: "<+07>-7" },
      { name: "Asia/Pontianak", label: "Pontianak", posix: "WIB-7" },
      { name: "Asia/Pyongyang", label: "Pyongyang", posix: "KST-9" },
      { name: "Asia/Qatar", label: "Qatar", posix: "<+03>-3" },
      { name: "Asia/Qyzylorda", label: "Qyzylorda", posix: "<+05>-5" },
      { name: "Asia/Riyadh", label: "Riyadh", posix: "<+03>-3" },
      { name: "Asia/Sakhalin", label: "Sakhalin", posix: "<+11>-11" },
      { name: "Asia/Samarkand", label: "Samarkand", posix: "<+05>-5" },
      { name: "Asia/Seoul", label: "Seoul", posix: "KST-9" },
      { name: "Asia/Shanghai", label: "Shanghai", posix: "CST-8" },
      { name: "Asia/Singapore", label: "Singapore", posix: "<+08>-8" },
      { name: "Asia/Srednekolymsk", label: "Srednekolymsk", posix: "<+11>-11" },
      { name: "Asia/Taipei", label: "Taipei", posix: "CST-8" },
      { name: "Asia/Tashkent", label: "Tashkent", posix: "<+05>-5" },
      { name: "Asia/Tbilisi", label: "Tbilisi", posix: "<+04>-4" },
      { name: "Asia/Tehran", label: "Tehran", posix: "<+0330>-3:30" },
      { name: "Asia/Thimphu", label: "Thimphu", posix: "<+06>-6" },
      { name: "Asia/Tokyo", label: "Tokyo", posix: "JST-9" },
      { name: "Asia/Tomsk", label: "Tomsk", posix: "<+07>-7" },
      { name: "Asia/Ulaanbaatar", label: "Ulaanbaatar", posix: "<+08>-8" },
      { name: "Asia/Urumqi", label: "Urumqi", posix: "<+06>-6" },
      { name: "Asia/Ust-Nera", label: "Ust-Nera", posix: "<+10>-10" },
      { name: "Asia/Vientiane", label: "Vientiane", posix: "<+07>-7" },
      { name: "Asia/Vladivostok", label: "Vladivostok", posix: "<+10>-10" },
      { name: "Asia/Yakutsk", label: "Yakutsk", posix: "<+09>-9" },
      { name: "Asia/Yangon", label: "Yangon", posix: "<+0630>-6:30" },
      { name: "Asia/Yekaterinburg", label: "Yekaterinburg", posix: "<+05>-5" },
      { name: "Asia/Yerevan", label: "Yerevan", posix: "<+04>-4" },
    ],
  },
  {
    id: "Atlantic",
    zones: [
      { name: "Atlantic/Azores", label: "Azores", posix: "<-01>1<+00>,M3.5.0/0,M10.5.0/1" },
      { name: "Atlantic/Bermuda", label: "Bermuda", posix: "AST4ADT,M3.2.0,M11.1.0" },
      { name: "Atlantic/Canary", label: "Canary", posix: "WET0WEST,M3.5.0/1,M10.5.0" },
      { name: "Atlantic/Cape_Verde", label: "Cape Verde", posix: "<-01>1" },
      { name: "Atlantic/Faroe", label: "Faroe", posix: "WET0WEST,M3.5.0/1,M10.5.0" },
      { name: "Atlantic/Madeira", label: "Madeira", posix: "WET0WEST,M3.5.0/1,M10.5.0" },
      { name: "Atlantic/Reykjavik", label: "Reykjavik", posix: "GMT0" },
      { name: "Atlantic/South_Georgia", label: "South Georgia", posix: "<-02>2" },
      { name: "Atlantic/St_Helena", label: "St Helena", posix: "GMT0" },
      { name: "Atlantic/Stanley", label: "Stanley", posix: "<-03>3" },
    ],
  },
  {
    id: "Australia",
    zones: [
      { name: "Australia/Adelaide", label: "Adelaide", posix: "ACST-9:30ACDT,M10.1.0,M4.1.0/3" },
      { name: "Australia/Brisbane", label: "Brisbane", posix: "AEST-10" },
      { name: "Australia/Broken_Hill", label: "Broken Hill", posix: "ACST-9:30ACDT,M10.1.0,M4.1.0/3" },
      { name: "Australia/Currie", label: "Currie", posix: "AEST-10AEDT,M10.1.0,M4.1.0/3" },
      { name: "Australia/Darwin", label: "Darwin", posix: "ACST-9:30" },
      { name: "Australia/Eucla", label: "Eucla", posix: "<+0845>-8:45" },
      { name: "Australia/Hobart", label: "Hobart", posix: "AEST-10AEDT,M10.1.0,M4.1.0/3" },
      { name: "Australia/Lindeman", label: "Lindeman", posix: "AEST-10" },
      { name: "Australia/Lord_Howe", label: "Lord Howe", posix: "<+1030>-10:30<+11>-11,M10.1.0,M4.1.0" },
      { name: "Australia/Melbourne", label: "Melbourne", posix: "AEST-10AEDT,M10.1.0,M4.1.0/3" },
      { name: "Australia/Perth", label: "Perth", posix: "AWST-8" },
      { name: "Australia/Sydney", label: "Sydney", posix: "AEST-10AEDT,M10.1.0,M4.1.0/3" },
    ],
  },
  {
    id: "Indian",
    zones: [
      { name: "Indian/Antananarivo", label: "Antananarivo", posix: "EAT-3" },
      { name: "Indian/Chagos", label: "Chagos", posix: "<+06>-6" },
      { name: "Indian/Christmas", label: "Christmas", posix: "<+07>-7" },
      { name: "Indian/Cocos", label: "Cocos", posix: "<+0630>-6:30" },
      { name: "Indian/Comoro", label: "Comoro", posix: "EAT-3" },
      { name: "Indian/Kerguelen", label: "Kerguelen", posix: "<+05>-5" },
      { name: "Indian/Mahe", label: "Mahe", posix: "<+04>-4" },
      { name: "Indian/Maldives", label: "Maldives", posix: "<+05>-5" },
      { name: "Indian/Mauritius", label: "Mauritius", posix: "<+04>-4" },
      { name: "Indian/Mayotte", label: "Mayotte", posix: "EAT-3" },
      { name: "Indian/Reunion", label: "Reunion", posix: "<+04>-4" },
    ],
  },
  {
    id: "Pacific",
    zones: [
      { name: "Pacific/Apia", label: "Apia", posix: "<+13>-13" },
      { name: "Pacific/Auckland", label: "Auckland", posix: "NZST-12NZDT,M9.5.0,M4.1.0/3" },
      { name: "Pacific/Bougainville", label: "Bougainville", posix: "<+11>-11" },
      { name: "Pacific/Chatham", label: "Chatham", posix: "<+1245>-12:45<+1345>,M9.5.0/2:45,M4.1.0/3:45" },
      { name: "Pacific/Chuuk", label: "Chuuk", posix: "<+10>-10" },
      { name: "Pacific/Easter", label: "Easter", posix: "<-06>6<-05>,M9.1.6/22,M4.1.6/22" },
      { name: "Pacific/Efate", label: "Efate", posix: "<+11>-11" },
      { name: "Pacific/Enderbury", label: "Enderbury", posix: "<+13>-13" },
      { name: "Pacific/Fakaofo", label: "Fakaofo", posix: "<+13>-13" },
      { name: "Pacific/Fiji", label: "Fiji", posix: "<+12>-12" },
      { name: "Pacific/Funafuti", label: "Funafuti", posix: "<+12>-12" },
      { name: "Pacific/Galapagos", label: "Galapagos", posix: "<-06>6" },
      { name: "Pacific/Gambier", label: "Gambier", posix: "<-09>9" },
      { name: "Pacific/Guadalcanal", label: "Guadalcanal", posix: "<+11>-11" },
      { name: "Pacific/Guam", label: "Guam", posix: "ChST-10" },
      { name: "Pacific/Honolulu", label: "Honolulu", posix: "HST10" },
      { name: "Pacific/Kiritimati", label: "Kiritimati", posix: "<+14>-14" },
      { name: "Pacific/Kosrae", label: "Kosrae", posix: "<+11>-11" },
      { name: "Pacific/Kwajalein", label: "Kwajalein", posix: "<+12>-12" },
      { name: "Pacific/Majuro", label: "Majuro", posix: "<+12>-12" },
      { name: "Pacific/Marquesas", label: "Marquesas", posix: "<-0930>9:30" },
      { name: "Pacific/Midway", label: "Midway", posix: "SST11" },
      { name: "Pacific/Nauru", label: "Nauru", posix: "<+12>-12" },
      { name: "Pacific/Niue", label: "Niue", posix: "<-11>11" },
      { name: "Pacific/Norfolk", label: "Norfolk", posix: "<+11>-11<+12>,M10.1.0,M4.1.0/3" },
      { name: "Pacific/Noumea", label: "Noumea", posix: "<+11>-11" },
      { name: "Pacific/Pago_Pago", label: "Pago Pago", posix: "SST11" },
      { name: "Pacific/Palau", label: "Palau", posix: "<+09>-9" },
      { name: "Pacific/Pitcairn", label: "Pitcairn", posix: "<-08>8" },
      { name: "Pacific/Pohnpei", label: "Pohnpei", posix: "<+11>-11" },
      { name: "Pacific/Port_Moresby", label: "Port Moresby", posix: "<+10>-10" },
      { name: "Pacific/Rarotonga", label: "Rarotonga", posix: "<-10>10" },
      { name: "Pacific/Saipan", label: "Saipan", posix: "ChST-10" },
      { name: "Pacific/Tahiti", label: "Tahiti", posix: "<-10>10" },
      { name: "Pacific/Tarawa", label: "Tarawa", posix: "<+12>-12" },
      { name: "Pacific/Tongatapu", label: "Tongatapu", posix: "<+13>-13" },
      { name: "Pacific/Wake", label: "Wake", posix: "<+12>-12" },
      { name: "Pacific/Wallis", label: "Wallis", posix: "<+12>-12" },
    ],
  },
  {
    id: "Antarctica",
    zones: [
      { name: "Antarctica/Casey", label: "Casey", posix: "<+08>-8" },
      { name: "Antarctica/Davis", label: "Davis", posix: "<+07>-7" },
      { name: "Antarctica/DumontDUrville", label: "DumontDUrville", posix: "<+10>-10" },
      { name: "Antarctica/Macquarie", label: "Macquarie", posix: "AEST-10AEDT,M10.1.0,M4.1.0/3" },
      { name: "Antarctica/Mawson", label: "Mawson", posix: "<+05>-5" },
      { name: "Antarctica/McMurdo", label: "McMurdo", posix: "NZST-12NZDT,M9.5.0,M4.1.0/3" },
      { name: "Antarctica/Palmer", label: "Palmer", posix: "<-03>3" },
      { name: "Antarctica/Rothera", label: "Rothera", posix: "<-03>3" },
      { name: "Antarctica/Syowa", label: "Syowa", posix: "<+03>-3" },
      { name: "Antarctica/Troll", label: "Troll", posix: "<+00>0<+02>-2,M3.5.0/1,M10.5.0/3" },
      { name: "Antarctica/Vostok", label: "Vostok", posix: "<+05>-5" },
    ],
  },
  {
    id: "Arctic",
    zones: [
      { name: "Arctic/Longyearbyen", label: "Longyearbyen", posix: "CET-1CEST,M3.5.0,M10.5.0/3" },
    ],
  },
  {
    id: "Etc",
    zones: [
      { name: "Etc/GMT", label: "GMT", posix: "GMT0" },
      { name: "Etc/GMT-0", label: "GMT-0", posix: "GMT0" },
      { name: "Etc/GMT-1", label: "GMT-1", posix: "<+01>-1" },
      { name: "Etc/GMT-10", label: "GMT-10", posix: "<+10>-10" },
      { name: "Etc/GMT-11", label: "GMT-11", posix: "<+11>-11" },
      { name: "Etc/GMT-12", label: "GMT-12", posix: "<+12>-12" },
      { name: "Etc/GMT-13", label: "GMT-13", posix: "<+13>-13" },
      { name: "Etc/GMT-14", label: "GMT-14", posix: "<+14>-14" },
      { name: "Etc/GMT-2", label: "GMT-2", posix: "<+02>-2" },
      { name: "Etc/GMT-3", label: "GMT-3", posix: "<+03>-3" },
      { name: "Etc/GMT-4", label: "GMT-4", posix: "<+04>-4" },
      { name: "Etc/GMT-5", label: "GMT-5", posix: "<+05>-5" },
      { name: "Etc/GMT-6", label: "GMT-6", posix: "<+06>-6" },
      { name: "Etc/GMT-7", label: "GMT-7", posix: "<+07>-7" },
      { name: "Etc/GMT-8", label: "GMT-8", posix: "<+08>-8" },
      { name: "Etc/GMT-9", label: "GMT-9", posix: "<+09>-9" },
      { name: "Etc/GMT+0", label: "GMT+0", posix: "GMT0" },
      { name: "Etc/GMT+1", label: "GMT+1", posix: "<-01>1" },
      { name: "Etc/GMT+10", label: "GMT+10", posix: "<-10>10" },
      { name: "Etc/GMT+11", label: "GMT+11", posix: "<-11>11" },
      { name: "Etc/GMT+12", label: "GMT+12", posix: "<-12>12" },
      { name: "Etc/GMT+2", label: "GMT+2", posix: "<-02>2" },
      { name: "Etc/GMT+3", label: "GMT+3", posix: "<-03>3" },
      { name: "Etc/GMT+4", label: "GMT+4", posix: "<-04>4" },
      { name: "Etc/GMT+5", label: "GMT+5", posix: "<-05>5" },
      { name: "Etc/GMT+6", label: "GMT+6", posix: "<-06>6" },
      { name: "Etc/GMT+7", label: "GMT+7", posix: "<-07>7" },
      { name: "Etc/GMT+8", label: "GMT+8", posix: "<-08>8" },
      { name: "Etc/GMT+9", label: "GMT+9", posix: "<-09>9" },
      { name: "Etc/GMT0", label: "GMT0", posix: "GMT0" },
      { name: "Etc/Greenwich", label: "Greenwich", posix: "GMT0" },
      { name: "Etc/UCT", label: "UCT", posix: "UTC0" },
      { name: "Etc/Universal", label: "Universal", posix: "UTC0" },
      { name: "Etc/UTC", label: "UTC", posix: "UTC0" },
      { name: "Etc/Zulu", label: "Zulu", posix: "UTC0" },
    ],
  },
];

function cityKey(value) {
  return String(value ?? '').trim().toLowerCase().replace(/[\s_]+/g, '');
}

/**
 * Zona del equipo ("Europe/Madrid" o, en datos antiguos, "Madrid") → región,
 * texto entero y regla POSIX. Devuelve null si no está en el listado.
 */
export function findLumZoneByCity(city) {
  const key = cityKey(city);
  if (!key) {
    return null;
  }

  for (const region of LumTimeZoneRegions) {
    for (const zone of region.zones) {
      const label = cityKey(zone.label);
      const lastSegment = cityKey(zone.name.split('/').pop());
      if (label === key || lastSegment === key || cityKey(zone.name) === key) {
        return { region: region.id, city: zone.label, name: zone.name, posix: zone.posix };
      }
    }
  }

  return null;
}

/** Ids de región para el desplegable: Europe, Africa, America… */
export function lumTimeZoneRegionIds() {
  return LumTimeZoneRegions.map((region) => region.id);
}

/** Texto entero de cada zona de una región (p. ej. "Europe/Madrid"). */
export function lumCitiesByRegion(regionId) {
  const region = LumTimeZoneRegions.find((item) => item.id === regionId);
  return region ? region.zones.map((zone) => zone.name) : [];
}
